import ApiConstants from "../../Globals/ApiConstants";
import { setAuthToken, setUser } from "../../Utils/localStorage";

const initialState = {
    getListOnload: false,
    createCustomerOnload: false,
    createCustomerData: null,
    mergeCustomerOnload: false,
    mergeCustomerData: null,
    setCustomerCreditLimitOnload: false,
    setCustomerCreditLimitData: null,
    addCustomerCreditOpeningBalanceOnload: false,
    addCustomerCreditOpeningBalanceData: null,
    recordCustomerCreditSettlementOnload: false,
    recordCustomerCreditSettlementData: null,
    customerCreditLedgerOnload: false,
    customerCreditLedgerData: null,
    updateProductColorAndSizeOnload: false,
    addProductOnload: false,
    categoryAndSubCategoryOnload: false,
    categoryAndSubCategoryData: null,
    updateProductStatusOnload: false,
    updateStickeringStatusOnload: false,
    productListOnload: false,
    productListData: null,
    customerListOnload: false,
    customerListData: null,
    getReferenceOnload: false,
    colorReferenceData: null,
    productItemListOnload: false,
    productItemList: null,
    billingListOnload: false,
    billingList: null,
    billNavigationRowOnload: false,
    billNavigationRow: null,
    productList: [],
    paymentTypeData: null,
    billTypeData: null,
    stateReferenceData: null,
    createBillReducerOnload: false,
    createBillReducerOnload_V2: false,
    createBillReducerData_V2: null,
    productItemListData: [],
    apparelLoginOnload: false,
    apparelLoginData: null,
    sendLoginOtpOnload: false,
    sendLoginOtpData: null,
    verifyLoginOtpOnload: false,
    verifyLoginOtpData: null,
    getCustomerHistoryOnload: false,
    getCustomerHistoryData: null,
    getEmployeeSalesHistoryOnload: false,
    getEmployeeSalesHistoryData: null,
    totalDiscount: [],
    getProductHistoryOnload: false,
    getProductHistoryData: null,
    getInvoiceDetailsOnload: false,
    getInvoiceDetailsData: null,
    barcodeList: null,
    getMultipleInventoryCountOnload: false,
    getMultipleInventoryCountData: null,
    getMultipleInventorySoldOnload: false,
    getMultipleInventorySoldData: null,
    getMultipleInventoryDamagedOnload: false,
    getMultipleInventoryDamagedData: null,
    createOrUpdateCycleCountLoad: false,
    getCycleCountListData: null,
    getCycleCountListLoad: false,
    cycleCountListSearchLoad: false,
    getMultipleCategoryListOnLoad: false,
    getMultipleCategoryListData: null,
    getProductListCategoryListOnLoad: false,
    getProductListCategoryData: null,
    getUpdateCycleCountOnLoad: false,
    getUpdateCycleCountData: null,
    getUpdateCycleCountList: false,
    getUpdateCycleCountListData: null,
    getMultipleScrapList: false,
    getMultipleScrapListData: null,
    getCycleCountReportOnLoad: false,
    getCycleCountReportData: null,
    getReportListOnLoad: false,
    getReportListData: null,
    getVendorListOnLoad: false,
    getVendorListData: null,
    getVendorDebtLedgerOnLoad: false,
    getVendorDebtLedgerData: null,
    createVendorDebtEntryOnLoad: false,
    createVendorDebtEntryData: null,
    createOrUpdateVendorOnLoad: false,
    getVendorEmailValidationOnLoad: false,
    getVendorEmailValidationData: null,
    getVendorDropDownListOnLoad: false,
    genVendorDropDownListData: null,
    getVendorPurchaseListOnLoad: false,
    getVendorPurchaseListData: null,
    createOrUpdateVendorPurchaseOnLoad: false,
    createOrUpdateVendorPurchaseData: null,
    getRentalListOnLoad: false,
    getRentalListData: null,
    createOrUpdateRentalOnLoad: false,
    createOrUpdateRentalData: null,
    getVendorPurchaseHistoryOnLoad: false,
    getVendorPurchaseHistoryData: null,
    getMrpListOnLoad: false,
    getMrpListData: null,
    getEmployeeListOnLoad: false,
    getEmployeeListData: null,
    createOrUpdateEmployeeOnLoad: false,
    getEmployeeDropDownListOnLoad: false,
    genEmployeeDropDownListData: null,
    referenceDataByGroupId: {},
    getAttendanceListLoad: false,
    getAttendanceListData: null,
    getEmployeeAttendanceCalendarLoad: false,
    getEmployeeAttendanceCalendarData: null,
    lastRequestedEmployeeAttendanceCalendarParams: null as any,
    getEmployeeAttendanceSummaryLoad: false,
    getEmployeeAttendanceSummaryData: null,
    lastRequestedEmployeeAttendanceSummaryParams: null as any,
    getAttendanceRecordByIdLoad: false,
    getAttendanceRecordByIdData: null,
    markAttendanceLoad: false,
    markAttendanceData: null,
    createOrUpdateProcurementData: null,
    createOrUpdateProcurementOnLoad: false,
    grtProcurementOnLoad: false,
    getProcurementData: null,
    getProcurementExportListOnLoad: false,
    getProcurementExportListData: null,
    getAuditLogListOnLoad: false,
    getAuditLogListData: null,
    createOrUpdateAttachmentLoad: false,
    getCreateOrUpdateData: true,
    getAttachmentLoad: false,
    getAttachmentData: null,
    getVendorBillAttachmentLoad: false,
    getVendorBillAttachmentData: null,
    getVendorDebtAttachmentLoad: false,
    getVendorDebtAttachmentData: null,
    getSalesReturnOnLoad: false,
    getSalesReturnData: null,
    createOrUpdateSalesReturnOnLoad: false,
    createOrUpdateSalesReturn: null,
    getSalesReturnBasedOnProductIdOnLoad: false,
    getSalesReturnBasedOnProductId: null,
    getSalesReturnBillDetailsOnLoad: false,
    getSalesReturnBillDetailsData: null,
    addCategoryLoad: false,
    addCategoryData: null,
    createOrUpdateBannerLoad: false,
    createOrUpdateBannerData: null,
    addSubCategoryLoad: false,
    addSubCategoryData: null,
    getMetaBannerLoad: false,
    getMetaBannerData: null,
    getBannerAttachmentLoad: false,
    getBannerAttachmentData: null,
    getHotNewTopPickLoad: false,
    getHotNewTopPickData: null,
    updateHotNewTopPickLoad: false,
    updateHotNewTopPickData: false,
    getOnlineOrderLoad: false,
    getOnlineOrderData: null,
    updateOnlineOrderActionLoad: false,
    updateOnlieOrderActionData: null,
    getCoreCategoryDataLoad: false,
    getCoreCategoryData: null,
    getDashboardDataLoad: false,
    getDashboardData: null,
    getTopProductsLoad: false,
    getTopProductsData: null,
    getTopCustomersLoad: false,
    getTopCustomersData: null,
    getSalesDashboardDataLoad: false,
    getSalesDashboardData: null,
    getInventoryDashboardDataLoad: false,
    getInventoryDashboardData: null,
    getCustomerDashboardDataLoad: false,
    getCustomerDashboardData: null,
    getVendorDashboardDataLoad: false,
    getVendorDashboardData: null,
    getEmployeeDashboardDataLoad: false,
    getEmployeeDashboardData: null,
    getCustomDashboardDataLoad: false,
    getCustomDashboardData: null,
    getFeedbackDashboardDataLoad: false,
    getFeedbackDashboardData: null,
    getFeedbackListLoad: false,
    getFeedbackList: null,
    getFeedbackLocationsLoad: false,
    getFeedbackLocations: null,
    getStockHistoryLoad: false,
    getStockHistoryData: null,
    getStockMovementHistoryLoad: false,
    getStockMovementHistoryData: null,
    adminAdjustStockLoad: false,
    adminAdjustStockData: null,
    // Own slices (not productListData) so the combo picker / component list
    // never overwrite the main stock table's data.
    getComboComponentOptionsLoad: false,
    getComboComponentOptionsData: null,
    getComboItemsLoad: false,
    getComboItemsData: null,
    getComboItemsFor: null,
    addProductResult: null
}

const setAuthOrUser = (result: any, state: any) => {
    try {
        if (result) {
            setUser(result?.user)
            setAuthToken(result?.auth_token)
            state.status = 1;
        } else {
            state.status = 4;
        }
    } catch (ex: any) {
    }
}
function ApparelReducerState(state = initialState, action: any) {
    switch (action?.type) {
        case ApiConstants?.API_GET_LIST_LOAD:
            return {
                ...state,
                getListOnload: true
            }
        case ApiConstants?.API_GET_LIST_SUCCESS:
            return {
                ...state,
                getListOnload: false
            }
        case ApiConstants?.API_CREATE_CUSTOMER_LOAD:
            return {
                ...state,
                createCustomerOnload: true
            }
        case ApiConstants?.API_CREATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                createCustomerOnload: false,
                createCustomerData: action?.result
            }
        case ApiConstants?.API_MERGE_CUSTOMER_LOAD:
            return {
                ...state,
                mergeCustomerOnload: true
            }
        case ApiConstants?.API_MERGE_CUSTOMER_SUCCESS:
            return {
                ...state,
                mergeCustomerOnload: false,
                mergeCustomerData: action?.result
            }
        case ApiConstants?.API_SET_CUSTOMER_CREDIT_LIMIT_LOAD:
            return {
                ...state,
                setCustomerCreditLimitOnload: true
            }
        case ApiConstants?.API_SET_CUSTOMER_CREDIT_LIMIT_SUCCESS:
            return {
                ...state,
                setCustomerCreditLimitOnload: false,
                setCustomerCreditLimitData: action?.result
            }
        case ApiConstants?.API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_LOAD:
            return {
                ...state,
                addCustomerCreditOpeningBalanceOnload: true
            }
        case ApiConstants?.API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_SUCCESS:
            return {
                ...state,
                addCustomerCreditOpeningBalanceOnload: false,
                addCustomerCreditOpeningBalanceData: action?.result
            }
        case ApiConstants?.API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_LOAD:
            return {
                ...state,
                recordCustomerCreditSettlementOnload: true
            }
        case ApiConstants?.API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_SUCCESS:
            return {
                ...state,
                recordCustomerCreditSettlementOnload: false,
                recordCustomerCreditSettlementData: action?.result
            }
        case ApiConstants?.API_GET_CUSTOMER_CREDIT_LEDGER_LOAD:
            return {
                ...state,
                customerCreditLedgerOnload: true
            }
        case ApiConstants?.API_GET_CUSTOMER_CREDIT_LEDGER_SUCCESS:
            return {
                ...state,
                customerCreditLedgerOnload: false,
                customerCreditLedgerData: action?.result
            }
        case ApiConstants?.API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_LOAD:
            return {
                ...state,
                updateProductColorAndSizeOnload: true
            }
        case ApiConstants?.API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_SUCCESS:
            return {
                ...state,
                updateProductColorAndSizeOnload: false
            }
        case ApiConstants?.API_ADD_PRODUCT_LOAD:
            return {
                ...state,
                addProductOnload: true,
                addProductResult: null
            }
        case ApiConstants?.API_ADD_PRODUCT_SUCCESS:
            return {
                ...state,
                addProductOnload: false,
                // createProduct_v2's message ("Created Successfully" or a
                // validation error such as a combo item shortfall).
                addProductResult: action?.result?.data?.createProduct_v2 ?? null
            }
        case ApiConstants?.API_CATEGORY_AND_SUBCATEGORY_LIST_LOAD:
            return {
                ...state,
                categoryAndSubCategoryOnload: true
            }
        case ApiConstants?.API_CATEGORY_AND_SUBCATEGORY_LIST_SUCCESS:
            return {
                ...state,
                categoryAndSubCategoryOnload: false,
                categoryAndSubCategoryData: action?.result
            }
        case ApiConstants?.API_UPDATE_PRODUCT_STATUS_LOAD:
            return {
                ...state,
                updateProductStatusOnload: true
            }
        case ApiConstants?.API_UPDATE_PRODUCT_STATUS_SUCCESS:
            return {
                ...state,
                updateProductStatusOnload: false
            }
        case ApiConstants?.API_UPDATE_STICKERING_LOAD:
            return {
                ...state,
                updateStickeringStatusOnload: true
            }
        case ApiConstants?.API_UPDATE_STICKERING_SUCCESS:
            return {
                ...state,
                updateStickeringStatusOnload: false
            }
        case ApiConstants?.API_GET_PRODUCT_LIST_LOAD:
            return {
                ...state,
                productListOnload: true
            }
        case ApiConstants?.API_GET_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                productListOnload: false,
                productListData: action?.result
            }
        case ApiConstants?.API_GET_CUSTOMER_LIST_LOAD:
            return {
                ...state,
                customerListOnload: true
            }
        case ApiConstants?.API_GET_CUSTOMER_LIST_SUCCESS:
            return {
                ...state,
                customerListOnload: false,
                customerListData: action?.result
            }
        case ApiConstants?.API_GET_REFERENCE_DATA_LOAD:
            return {
                ...state,
                getReferenceOnload: true
            }
        case ApiConstants?.API_GET_REFERENCE_DATA_SUCCESS:
            if (action?.payload?.referenceGroupId == 1) {
                return {
                    ...state,
                    getReferenceOnload: false,
                    colorReferenceData: action?.result
                }
            } else if (action?.payload?.referenceGroupId == 2) {
                return {
                    ...state,
                    getReferenceOnload: false,
                    sizeReferenceData: action?.result
                }
            } else if (action?.payload?.referenceGroupId == 3) {
                return {
                    ...state,
                    getReferenceOnload: false,
                    billTypeData: action?.result
                }
            } else if (action?.payload?.referenceGroupId == 4) {
                return {
                    ...state,
                    getReferenceOnload: false,
                    paymentTypeData: action?.result
                }
            } else if (action?.payload?.referenceGroupId == 7) {
                return {
                    ...state,
                    getReferenceOnload: false,
                    stateReferenceData: action?.result
                }
            }
            else {
                return {
                    ...state,
                    getReferenceOnload: false,
                    referenceDataByGroupId: {
                        ...state.referenceDataByGroupId,
                        [action?.payload?.referenceGroupId]: action?.result
                    }
                }
            }
        case ApiConstants?.API_GET_PRODUCT_ITEM_LOAD:
            return {
                ...state,
                productItemListOnload: true
            }
        case ApiConstants?.API_GET_PRODUCT_ITEM_SUCCESS:
            return {
                ...state,
                productItemListOnload: false,
                productItemList: action?.result
            }
        case ApiConstants?.API_CREATE_BILL_LOAD:
            return {
                ...state,
                createBillReducerOnload: true
            }
        case ApiConstants?.API_CREATE_BILL_SUCCESS:
            return {
                ...state,
                createBillReducerOnload: false
            }
        case ApiConstants?.API_CREATE_BILL_V2_LOAD:
            return {
                ...state,
                createBillReducerOnload_V2: true
            }
        case ApiConstants?.API_CREATE_BILL_V2_SUCCESS:
            return {
                ...state,
                createBillReducerOnload_V2: false,
                createBillReducerData_V2: action?.result
            }
        case ApiConstants?.API_GET_BILLING_LIST_LOAD:
            return {
                ...state,
                billingListOnload: true
            }
        case ApiConstants?.API_GET_BILLING_LIST_SUCCESS:
            return {
                ...state,
                billingListOnload: false,
                billingList: action?.result
            }
        case ApiConstants?.API_GET_BILL_NAVIGATION_ROW_LOAD:
            return {
                ...state,
                billNavigationRowOnload: true
            }
        case ApiConstants?.API_GET_BILL_NAVIGATION_ROW_SUCCESS:
            return {
                ...state,
                billNavigationRowOnload: false,
                billNavigationRow: action?.result
            }
        case ApiConstants?.CLEAR_PRODUCT_ITEM_LIST:

            return {
                productList: [],
                productItemListData: [],
                totalDiscount: []
            }
        case ApiConstants?.REMOVED_PRODUCT_ITEM_LIST:

            state.productList = state?.productList?.filter((x: any) => x?.productId != action?.payload?.productId);
            state.productItemListData = state?.productItemListData?.filter((x: any) => x?.productItemId != action?.payload?.productItemId);
            state.totalDiscount = state?.totalDiscount?.filter((x: any) => x?.productItemId != action?.payload?.productItemId)
            return {
                ...state,
            }
        case ApiConstants?.UPDATE_PRODUCT_ITEM_LIST:
            let productList = state.productList.map((product: any) => {
                if (product.productId === action?.payload?.productId) {
                    return {
                        ...product,
                        total: action?.payload?.total,
                        discount: action?.payload?.discount,
                    };
                }
                return product;
            });
            let productItemListData = state?.productItemListData?.map((productItem: any) => {
                if (productItem.productItemId === action?.payload?.productItemId) {
                    return {
                        ...productItem,
                        discountPercentage: action?.payload?.discount,
                    };
                }
                return productItem;
            });
            let totalDiscount = state?.totalDiscount?.map((productDiscount: any) => {
                if (productDiscount.productItemId === action?.payload?.productItemId) {
                    return {
                        ...productDiscount,
                        discount: action?.payload?.discountData,
                    };
                }
                return productDiscount;
            })
            return {
                ...state,
                productList: productList,
                productItemListData: productItemListData,
                totalDiscount: totalDiscount
            }
        case ApiConstants.UPDATE_PRODUCT_ITEM_QUANTITY:
            return {
                ...state,
                productItemListData: state.productItemListData.map((item: any) =>
                    item.productItemId === action.payload.productItemId
                        ? { ...item, quantity: Number(action.payload.quantity) }
                        : item
                ),
                productList: state.productList.map((product: any) => {
                    if (product.productItemId === action.payload.productItemId) {
                        const quantity = parseFloat(action.payload.quantity || 0);
                        const mrp = parseFloat(product.mrp || 0);
                        const discount = parseFloat(product.discount || 0);

                        const grossTotal = mrp * quantity;
                        const discountAmount = (discount / 100) * grossTotal;
                        const total = grossTotal - discountAmount;

                        return {
                            ...product,
                            quantity: Number(action.payload.quantity),
                            total: parseFloat(total.toFixed(2)),
                        };
                    }
                    return product;
                }),
            };

        case ApiConstants?.API_APPAREL_LOGIN_LOAD:
            return {
                ...state,
                apparelLoginOnload: true
            }
        case ApiConstants?.API_APPAREL_LOGIN_SUCCESS:
            if (action?.result?.login?.user) {
                setAuthOrUser(action?.result?.login, state)
                setUser(action?.result?.login?.user)
                let url = action?.result?.login?.user?.roleId == 1 ? "/inventoryManagement" : "/billing"
                window.location.href = url;
            }
            return {
                ...state,
                apparelLoginOnload: false,
                apparelLoginData: action?.result
            }
        case ApiConstants?.API_SEND_LOGIN_OTP_LOAD:
            return {
                ...state,
                sendLoginOtpOnload: true
            }
        case ApiConstants?.API_SEND_LOGIN_OTP_SUCCESS:
            return {
                ...state,
                sendLoginOtpOnload: false,
                sendLoginOtpData: action?.result
            }
        case ApiConstants?.API_VERIFY_LOGIN_OTP_LOAD:
            return {
                ...state,
                verifyLoginOtpOnload: true
            }
        case ApiConstants?.API_VERIFY_LOGIN_OTP_SUCCESS:
            if (action?.result?.login?.user) {
                setAuthOrUser(action?.result?.login, state)
                setUser(action?.result?.login?.user)
                let url = action?.result?.login?.user?.roleId == 1 ? "/inventoryManagement" : "/billing"
                window.location.href = url;
            }
            return {
                ...state,
                verifyLoginOtpOnload: false,
                verifyLoginOtpData: action?.result
            }
        case ApiConstants?.CLEAR_LOGIN_OTP_STATE:
            return {
                ...state,
                sendLoginOtpOnload: false,
                sendLoginOtpData: null,
                verifyLoginOtpOnload: false,
                verifyLoginOtpData: null
            }
        case ApiConstants?.API_GET_CUSTOMER_HISTORY_LOAD:
            return {
                ...state,
                getCustomerHistoryOnload: true
            }
        case ApiConstants?.API_GET_CUSTOMER_HISTORY_SUCCESS:
            return {
                ...state,
                getCustomerHistoryOnload: false,
                getCustomerHistoryData: action?.result
            }
        case ApiConstants?.API_GET_EMPLOYEE_SALES_HISTORY_LOAD:
            return {
                ...state,
                getEmployeeSalesHistoryOnload: true
            }
        case ApiConstants?.API_GET_EMPLOYEE_SALES_HISTORY_SUCCESS:
            return {
                ...state,
                getEmployeeSalesHistoryOnload: false,
                getEmployeeSalesHistoryData: action?.result
            }
        case ApiConstants?.API_GET_PRODUCT_HISTORY_LOAD:
            return {
                ...state,
                getProductHistoryOnload: true
            }
        case ApiConstants?.API_GET_PRODUCT_HISTORY_SUCCESS:
            return {
                ...state,
                getProductHistoryOnload: false,
                getProductHistoryData: action?.result
            }
        case ApiConstants?.API_GET_INVOICE_DETAILS_LOAD:
            return {
                ...state,
                getInvoiceDetailsOnload: true
            }
        case ApiConstants?.API_GET_INVOICE_DETAILS_SUCCESS:
            return {
                ...state,
                getInvoiceDetailsOnload: false,
                getInvoiceDetailsData: action?.result
            }
        case ApiConstants?.GET_BARCODE_ZIP_FILE:
            return {
                ...state,
                barcodeList: action?.data
            }
        case ApiConstants?.API_UPDATE_MULTIPLE_INVENTORY_LOAD:
            return {
                ...state,
                updateMultipleInventory: true
            }
        case ApiConstants?.API_UPDATE_MULTIPLE_INVENTORY_SUCCESS:
            return {
                ...state,
                updateMultipleInventory: false
            }
        case ApiConstants?.API_GET_MULTIPLE_INVENTORY_COUNT_LOAD:
            return {
                ...state,
                getMultipleInventoryCountOnload: true
            }
        case ApiConstants?.Api_GET_MULTIPLE_INVENTORY_COUNT_SUCCESS:
            return {
                ...state,
                getMultipleInventoryCountOnload: false,
                getMultipleInventoryCountData: action?.result
            }
        case ApiConstants?.API_GET_MULTIPLE_INVENTORY_SOLD_LIST_LOAD:
            return {
                ...state,
                getMultipleInventorySoldOnload: true
            }
        case ApiConstants?.API_GET_MULTIPLE_INVENTORY_SOLD_LIST_SUCCESS:
            return {
                ...state,
                getMultipleInventorySoldOnload: false,
                getMultipleInventorySoldData: action?.result
            }
        case ApiConstants?.API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_LOAD:
            return {
                ...state,
                getMultipleInventoryDamagedOnload: true
            }
        case ApiConstants?.API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_SUCCESS:
            return {
                ...state,
                getMultipleInventoryDamagedOnload: false,
                getMultipleInventoryDamagedData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_CYCLE_COUNT_LOAD:
            return {
                ...state,
                createOrUpdateCycleCountLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_CYCLE_COUNT_SUCCESS:
            return {
                ...state,
                createOrUpdateCycleCountLoad: false,
            }
        case ApiConstants?.API_GET_CYCLE_COUNT_LIST_LOAD:
            return {
                ...state,
                getCycleCountListLoad: true
            }
        case ApiConstants?.API_GET_CYCLE_COUNT_LIST_SUCCESS:
            return {
                ...state,
                getCycleCountListLoad: false,
                getCycleCountListData: action?.result
            }
        case ApiConstants?.API_CYCLE_COUNT_LIST_SEARCH_LOAD:
            return {
                ...state,
                cycleCountListSearchLoad: true
            }
        case ApiConstants?.API_CYCLE_COUNT_LIST_SEARCH_SUCCESS:
            return {
                ...state,
                cycleCountListSearchLoad: false,
            }
        case ApiConstants?.API_GET_CATEGORY_SUBCATEGORY_LIST_LOAD:
            return {
                ...state,
                getMultipleCategoryListOnLoad: true,
            }
        case ApiConstants?.API_GET_CATEGORY_SUBCATEGORY_LIST_SUCCESS:
            return {
                ...state,
                getMultipleCategoryListOnLoad: false,
                getMultipleCategoryListData: action?.result
            }

        case ApiConstants?.API_GET_PRODUCT_LIST_CATEGORY_LIST_LOAD:
            return {
                ...state,
                getProductListCategoryListOnLoad: true,
            }
        case ApiConstants?.API_GET_PRODUCT_LIST_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                getProductListCategoryListOnLoad: false,
                getProductListCategoryData: action?.result
            }
        case ApiConstants?.API_GET_UPDATE_CYCLE_COUNT_LOAD:
            return {
                ...state,
                getUpdateCycleCountOnLoad: true,
            }
        case ApiConstants?.API_GET_UPDATE_CYCLE_COUNT_SUCCESS:
            return {
                ...state,
                getUpdateCycleCountOnLoad: false,
                getUpdateCycleCountData: action?.result
            }
        case ApiConstants?.API_UPDATE_CYCLE_COUNT_LIST_LOAD:
            return {
                ...state,
                getUpdateCycleCountList: true,
            }
        case ApiConstants?.API_UPDATE_CYCLE_COUNT_LIST_SUCCESS:
            return {
                ...state,
                getUpdateCycleCountList: false,
                getUpdateCycleCountListData: action?.result
            }
        case ApiConstants?.API_GET_MULTIPLE_SCRAP_LIST_LOAD:
            return {
                ...state,
                getMultipleScrapList: true
            }
        case ApiConstants?.API_GET_MULTIPLE_SCRAP_LIST_SUCCESS:
            return {
                ...state,
                getMultipleScrapList: false,
                getMultipleScrapListData: action?.result
            }
        case ApiConstants?.API_GET_CYCLE_COUNT_REPORT_LOAD:
            return {
                ...state,
                getCycleCountReportOnLoad: true
            }
        case ApiConstants?.API_GET_CYCLE_COUNT_REPORT_SUCCESS:
            return {
                ...state,
                getCycleCountReportOnLoad: false,
                getCycleCountReportData: action?.result
            }

        case ApiConstants?.API_GET_REPORT_LIST_LOAD:
            return {
                ...state,
                getReportListOnLoad: true
            }
        case ApiConstants?.API_GET_REPORT_LIST_SUCCESS:
            return {
                ...state,
                getReportListOnLoad: false,
                getReportListData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_LIST_LOAD:
            return {
                ...state,
                getVendorListOnLoad: true
            }
        case ApiConstants?.API_GET_VENDOR_LIST_SUCCESS:
            return {
                ...state,
                getVendorListOnLoad: false,
                getVendorListData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_LOAD:
            return {
                ...state,
                createOrUpdateVendorOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_SUCCESS:
            return {
                ...state,
                createOrUpdateVendorOnLoad: false
            }
        case ApiConstants?.API_GET_VENDOR_EMAIL_VALIDATION_LOAD:
            return {
                ...state,
                getVendorEmailValidationOnLoad: true
            }
        case ApiConstants?.API_GET_VENDOR_EMAIL_VALIDATION_SUCCESS:
            return {
                ...state,
                getVendorEmailValidationOnLoad: false,
                getVendorEmailValidationData: action?.result
            }
        case ApiConstants?.CLEAR_SELECT_LOAD:
            return {
                ...state,
                productItemList: null
            }
        case ApiConstants?.VENDOR_DROP_DOWN_LIST_LOAD:
            return {
                ...state,
                getVendorDropDownListOnLoad: true
            }
        case ApiConstants?.VENDOR_DROP_DOWN_LIST_SUCCESS:
            return {
                ...state,
                getVendorDropDownListOnLoad: false,
                genVendorDropDownListData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_DEBT_LEDGER_LOAD:
            return {
                ...state,
                getVendorDebtLedgerOnLoad: true
            }
        case ApiConstants?.API_GET_VENDOR_DEBT_LEDGER_SUCCESS:
            return {
                ...state,
                getVendorDebtLedgerOnLoad: false,
                getVendorDebtLedgerData: action?.result
            }
        case ApiConstants?.API_CREATE_VENDOR_DEBT_ENTRY_LOAD:
            return {
                ...state,
                createVendorDebtEntryOnLoad: true
            }
        case ApiConstants?.API_CREATE_VENDOR_DEBT_ENTRY_SUCCESS:
            return {
                ...state,
                createVendorDebtEntryOnLoad: false,
                createVendorDebtEntryData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_PURCHASE_LIST_LOAD:
            return {
                ...state,
                getVendorPurchaseListOnLoad: true
            }
        case ApiConstants?.API_GET_VENDOR_PURCHASE_LIST_SUCCESS:
            return {
                ...state,
                getVendorPurchaseListOnLoad: false,
                getVendorPurchaseListData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_PURCHASE_LOAD:
            return {
                ...state,
                createOrUpdateVendorPurchaseOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_PURCHASE_SUCCESS:
            return {
                ...state,
                createOrUpdateVendorPurchaseOnLoad: false,
                createOrUpdateVendorPurchaseData: action?.result
            }
        case ApiConstants?.API_GET_RENTAL_LIST_LOAD:
            return {
                ...state,
                getRentalListOnLoad: true
            }
        case ApiConstants?.API_GET_RENTAL_LIST_SUCCESS:
            return {
                ...state,
                getRentalListOnLoad: false,
                getRentalListData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_RENTAL_LOAD:
            return {
                ...state,
                createOrUpdateRentalOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_RENTAL_SUCCESS:
            return {
                ...state,
                createOrUpdateRentalOnLoad: false,
                createOrUpdateRentalData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_PURCHASE_HISTORY_LOAD:
            return {
                ...state,
                getVendorPurchaseHistoryOnLoad: true
            }
        case ApiConstants?.API_GET_VENDOR_PURCHASE_HISTORY_SUCCESS:
            return {
                ...state,
                getVendorPurchaseHistoryOnLoad: false,
                getVendorPurchaseHistoryData: action?.result
            }
        case ApiConstants?.MRP_LIST_LOAD:
            return {
                ...state,
                getMrpListOnLoad: true
            }
        case ApiConstants?.MRP_LIST_SUCCESS:
            return {
                ...state,
                getMrpListOnLoad: false,
                getMrpListData: action?.result
            }
        case ApiConstants?.API_GET_EMPLOYEE_LIST_LOAD:
            return {
                ...state,
                getEmployeeListOnLoad: true
            }
        case ApiConstants?.API_GET_EMPLOYEE_LIST_SUCCESS:
            return {
                ...state,
                getEmployeeListOnLoad: false,
                getEmployeeListData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_EMPLOYEE_LOAD:
            return {
                ...state,
                createOrUpdateEmployeeOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                createOrUpdateEmployeeOnLoad: false
            }
        case ApiConstants?.EMPLOYEE_DROP_DOWN_LIST_LOAD:
            return {
                ...state,
                getEmployeeDropDownListOnLoad: true
            }
        case ApiConstants?.EMPLOYEE_DROP_DOWN_LIST_SUCCESS:
            return {
                ...state,
                getEmployeeDropDownListOnLoad: false,
                genEmployeeDropDownListData: action?.result
            }
        case ApiConstants?.API_GET_ATTENDANCE_LIST_LOAD:
            return {
                ...state,
                getAttendanceListLoad: true
            }
        case ApiConstants?.API_GET_ATTENDANCE_LIST_SUCCESS:
            return {
                ...state,
                getAttendanceListLoad: false,
                getAttendanceListData: action?.result
            }
        case ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_LOAD:
            return {
                ...state,
                getEmployeeAttendanceCalendarLoad: true,
                lastRequestedEmployeeAttendanceCalendarParams: action?.payload
            }
        case ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_SUCCESS:
            // A takeEvery-spawned fetch for a since-superseded employee/month/year
            // can resolve after a newer one was dispatched; only accept the
            // response that matches the most recently requested params so a
            // slow/out-of-order response can't clobber the current view.
            if (
                JSON.stringify(action?.requestPayload) !==
                JSON.stringify(state?.lastRequestedEmployeeAttendanceCalendarParams)
            ) {
                return state;
            }
            return {
                ...state,
                getEmployeeAttendanceCalendarLoad: false,
                getEmployeeAttendanceCalendarData: action?.result
            }
        case ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_LOAD:
            return {
                ...state,
                getEmployeeAttendanceSummaryLoad: true,
                lastRequestedEmployeeAttendanceSummaryParams: action?.payload
            }
        case ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS:
            if (
                JSON.stringify(action?.requestPayload) !==
                JSON.stringify(state?.lastRequestedEmployeeAttendanceSummaryParams)
            ) {
                return state;
            }
            return {
                ...state,
                getEmployeeAttendanceSummaryLoad: false,
                getEmployeeAttendanceSummaryData: action?.result
            }
        case ApiConstants?.API_GET_ATTENDANCE_RECORD_BY_ID_LOAD:
            return {
                ...state,
                getAttendanceRecordByIdLoad: true
            }
        case ApiConstants?.API_GET_ATTENDANCE_RECORD_BY_ID_SUCCESS:
            return {
                ...state,
                getAttendanceRecordByIdLoad: false,
                getAttendanceRecordByIdData: action?.result
            }
        case ApiConstants?.API_MARK_ATTENDANCE_LOAD:
            return {
                ...state,
                markAttendanceLoad: true
            }
        case ApiConstants?.API_MARK_ATTENDANCE_SUCCESS:
            return {
                ...state,
                markAttendanceLoad: false,
                markAttendanceData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_PROCUREMENT_LOAD:
            return {
                ...state,
                createOrUpdateProcurementOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_PROCUREMENT_SUCCESS:
            return {
                ...state,
                createOrUpdateProcurementOnLoad: false,
                createOrUpdateProcurementData: action?.result
            }
        case ApiConstants?.API_GET_PROCUREMENT_LIST_LOAD:
            return {
                ...state,
                grtProcurementOnLoad: true
            }
        case ApiConstants?.API_GET_PROCUREMENT_LIST_SUCCESS:
            return {
                ...state,
                grtProcurementOnLoad: false,
                getProcurementData: action?.result
            }
        case ApiConstants?.API_GET_PROCUREMENT_EXPORT_LIST_LOAD:
            return {
                ...state,
                getProcurementExportListOnLoad: true
            }
        case ApiConstants?.API_GET_PROCUREMENT_EXPORT_LIST_SUCCESS:
            return {
                ...state,
                getProcurementExportListOnLoad: false,
                getProcurementExportListData: action?.result
            }
        case ApiConstants?.API_GET_AUDIT_LOG_LIST_LOAD:
            return {
                ...state,
                getAuditLogListOnLoad: true
            }
        case ApiConstants?.API_GET_AUDIT_LOG_LIST_SUCCESS:
            return {
                ...state,
                getAuditLogListOnLoad: false,
                getAuditLogListData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_ATTACHMENT_LOAD:
            return {
                ...state,
                createOrUpdateAttachmentLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_ATTACHMENT_SUCCESSS:
            return {
                ...state,
                createOrUpdateAttachmentLoad: false,
                getCreateOrUpdateData: action?.result
            }
        case ApiConstants?.API_GET_ATTACHMENT_LOAD:
            return {
                ...state,
                getAttachmentLoad: true,
            }
        case ApiConstants?.API_GET_ATTACHMENT_SUCCESS:
            return {
                ...state,
                getAttachmentLoad: false,
                getAttachmentData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_BILL_ATTACHMENT_LOAD:
            return {
                ...state,
                getVendorBillAttachmentLoad: true,
            }
        case ApiConstants?.API_GET_VENDOR_BILL_ATTACHMENT_SUCCESS:
            return {
                ...state,
                getVendorBillAttachmentLoad: false,
                getVendorBillAttachmentData: action?.result
            }
        case ApiConstants?.API_GET_VENDOR_DEBT_ATTACHMENT_LOAD:
            return {
                ...state,
                getVendorDebtAttachmentLoad: true,
            }
        case ApiConstants?.API_GET_VENDOR_DEBT_ATTACHMENT_SUCCESS:
            return {
                ...state,
                getVendorDebtAttachmentLoad: false,
                getVendorDebtAttachmentData: action?.result
            }

        case ApiConstants?.API_GET_SALES_RETURN_LIST_LOAD:
            return {
                ...state,
                getSalesReturnOnLoad: true
            }
        case ApiConstants?.API_GET_SALES_RETURN_LIST_SUCCESS:
            return {
                ...state,
                getSalesReturnOnLoad: false,
                getSalesReturnData: action?.result
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_SALES_RETURN_LOAD:
            return {
                ...state,
                createOrUpdateSalesReturnOnLoad: true
            }
        case ApiConstants?.API_CREATE_OR_UPDATE_SALES_RETURN_SUCCESS:
            return {
                ...state,
                createOrUpdateSalesReturnOnLoad: false,
                createOrUpdateSalesReturn: action?.result
            }
        case ApiConstants?.API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_LOAD:
            return {
                ...state,
                getSalesReturnBasedOnProductIdOnLoad: true
            }
        case ApiConstants?.API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS:
            return {
                ...state,
                getSalesReturnBasedOnProductIdOnLoad: false,
                getSalesReturnBasedOnProductId: action?.result
            }
        case ApiConstants.API_CLEAR_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS:
            return {
                ...state,
                getSalesReturnBasedOnProductId: null
            }
        case ApiConstants?.API_GET_SALES_RETURN_BILL_DETAILS_LOAD:
            return {
                ...state,
                getSalesReturnBillDetailsOnLoad: true
            }
        case ApiConstants?.API_GET_SALES_RETURN_BILL_DETAILS_SUCCESS:
            return {
                ...state,
                getSalesReturnBillDetailsOnLoad: false,
                getSalesReturnBillDetailsData: action?.result
            }
        case ApiConstants.API_ADD_CATEGORY_ON_LOAD:
            return {
                ...state,
                addCategoryLoad: true
            }
        case ApiConstants.API_ADD_CATEGORY_ON_SUCCESS:
            return {
                ...state,
                addCategoryLoad: false,
                addCategoryData: action?.result
            }
        case ApiConstants?.API_CREATE_UPDATE_BANNER_LOAD:
            return {
                ...state,
                createOrUpdateBannerLoad: true
            }
        case ApiConstants?.API_CREATE_UPDATE_BANNER_SUCCESS:
            return {
                ...state,
                createOrUpdateBannerLoad: false,
                createOrUpdateBannerData: action?.result
            }
        case ApiConstants?.API_GET_BANNER_LOAD:
            return {
                ...state,
                getMetaBannerLoad: true
            }
        case ApiConstants?.API_GET_BANNER_SUCCESS:
            return {
                ...state,
                getMetaBannerLoad: false,
                getMetaBannerData: action?.result
            }
        case ApiConstants?.API_GET_BANNER_ATTACHMENT_LOAD:
            return {
                ...state,
                getBannerAttachmentLoad: true,
            }
        case ApiConstants?.API_GET_BANNER_ATTACHMENT_SUCCESS:
            return {
                ...state,
                getBannerAttachmentLoad: false,
                getBannerAttachmentData: action?.result
            }
        case ApiConstants.API_ADD_SUB_CATEGORY_ON_LOAD:
            return {
                ...state,
                addSubCategoryLoad: true
            }
        case ApiConstants.API_ADD_SUB_CATEGORY_ON_SUCCESS:
            return {
                ...state,
                addSubCategoryLoad: false,
                addSubCategoryData: action?.result
            }
        case ApiConstants.API_GET_HOT_NEW_TOP_PICK_LOAD:
            return {
                ...state,
                getHotNewTopPickLoad: true,
            }
        case ApiConstants.API_GET_HOT_NEW_TOP_PICK_SUCCESS:
            return {
                ...state,
                getHotNewTopPickLoad: false,
                getHotNewTopPickData: action?.result
            }
        case ApiConstants.API_UPDATE_HOT_NEW_TOP_PICK_LOAD:
            return {
                ...state,
                updateHotNewTopPickLoad: true,
            }
        case ApiConstants.API_UPDATE_HOT_NEW_TOP_PICK_SUCCESS:
            return {
                ...state,
                updateHotNewTopPickLoad: false,
                updateHotNewTopPickData: action?.result
            }
        case ApiConstants.API_GET_ONLINE_ORDER_LOAD:
            return {
                ...state,
                getOnlineOrderLoad: true
            }
        case ApiConstants.API_GET_ONLINE_ORDER_SUCCESS:
            return {
                ...state,
                getOnlineOrderLoad: false,
                getOnlineOrderData: action?.result
            }
        case ApiConstants.API_UPDATE_ONLINE_ORDER_LOAD:
            return {
                ...state,
                updateOnlineOrderActionLoad: true
            }
        case ApiConstants.API_UPDATE_ONLINE_ORDER_SUCCESS:
            return {
                ...state,
                updateOnlineOrderActionLoad: false,
                updateOnlieOrderActionData: action?.result
            }
        case ApiConstants.API_GET_CORE_CATEGORY_META_LOAD:
            return {
                ...state,
                getCoreCategoryDataLoad: true
            }
        case ApiConstants.API_GET_CORE_CATEGORY_META_SUCCESS:
            return {
                ...state,
                getCoreCategoryDataLoad: false,
                getCoreCategoryData: action?.result?.getCoreCategoryMeta

            }
        case ApiConstants.API_GET_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getDashboardDataLoad: true
            }
        case ApiConstants.API_GET_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getDashboardDataLoad: false,
                getDashboardData: action?.result
            }
        case ApiConstants.API_GET_TOP_PRODUCTS_LOAD:
            return {
                ...state,
                getTopProductsLoad: true
            }
        case ApiConstants.API_GET_TOP_PRODUCTS_SUCCESS:
            return {
                ...state,
                getTopProductsLoad: false,
                getTopProductsData: action?.result
            }
        case ApiConstants.API_GET_TOP_CUSTOMERS_LOAD:
            return {
                ...state,
                getTopCustomersLoad: true
            }
        case ApiConstants.API_GET_TOP_CUSTOMERS_SUCCESS:
            return {
                ...state,
                getTopCustomersLoad: false,
                getTopCustomersData: action?.result
            }
        case ApiConstants.API_GET_SALES_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getSalesDashboardDataLoad: true
            }
        case ApiConstants.API_GET_SALES_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getSalesDashboardDataLoad: false,
                getSalesDashboardData: action?.result
            }
        case ApiConstants.API_GET_INVENTORY_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getInventoryDashboardDataLoad: true
            }
        case ApiConstants.API_GET_INVENTORY_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getInventoryDashboardDataLoad: false,
                getInventoryDashboardData: action?.result
            }
        case ApiConstants.API_GET_CUSTOMER_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getCustomerDashboardDataLoad: true
            }
        case ApiConstants.API_GET_CUSTOMER_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getCustomerDashboardDataLoad: false,
                getCustomerDashboardData: action?.result
            }
        case ApiConstants.API_GET_VENDOR_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getVendorDashboardDataLoad: true
            }
        case ApiConstants.API_GET_VENDOR_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getVendorDashboardDataLoad: false,
                getVendorDashboardData: action?.result
            }
        case ApiConstants.API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getCustomerCreditDashboardDataLoad: true
            }
        case ApiConstants.API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getCustomerCreditDashboardDataLoad: false,
                getCustomerCreditDashboardData: action?.result
            }
        case ApiConstants.API_GET_VENDOR_DEBT_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getVendorDebtDashboardDataLoad: true
            }
        case ApiConstants.API_GET_VENDOR_DEBT_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getVendorDebtDashboardDataLoad: false,
                getVendorDebtDashboardData: action?.result
            }
        case ApiConstants.API_GET_UPCOMING_CUSTOMER_EVENTS_LOAD:
            return {
                ...state,
                getUpcomingCustomerEventsLoad: true
            }
        case ApiConstants.API_GET_UPCOMING_CUSTOMER_EVENTS_SUCCESS:
            return {
                ...state,
                getUpcomingCustomerEventsLoad: false,
                getUpcomingCustomerEventsData: action?.result
            }
        case ApiConstants.API_GET_EMPLOYEE_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getEmployeeDashboardDataLoad: true
            }
        case ApiConstants.API_GET_EMPLOYEE_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getEmployeeDashboardDataLoad: false,
                getEmployeeDashboardData: action?.result
            }
        case ApiConstants.API_GET_CUSTOM_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getCustomDashboardDataLoad: true
            }
        case ApiConstants.API_GET_CUSTOM_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getCustomDashboardDataLoad: false,
                getCustomDashboardData: action?.result
            }
        case ApiConstants.API_GET_FEEDBACK_DASHBOARD_DATA_LOAD:
            return {
                ...state,
                getFeedbackDashboardDataLoad: true
            }
        case ApiConstants.API_GET_FEEDBACK_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getFeedbackDashboardDataLoad: false,
                getFeedbackDashboardData: action?.result
            }
        case ApiConstants.API_GET_FEEDBACK_LIST_LOAD:
            return {
                ...state,
                getFeedbackListLoad: true
            }
        case ApiConstants.API_GET_FEEDBACK_LIST_SUCCESS:
            return {
                ...state,
                getFeedbackListLoad: false,
                getFeedbackList: action?.result
            }
        case ApiConstants.API_GET_FEEDBACK_LOCATIONS_LOAD:
            return {
                ...state,
                getFeedbackLocationsLoad: true
            }
        case ApiConstants.API_GET_FEEDBACK_LOCATIONS_SUCCESS:
            return {
                ...state,
                getFeedbackLocationsLoad: false,
                getFeedbackLocations: action?.result
            }
        case ApiConstants.API_GET_STOCK_HISTORY_LOAD:
            return {
                ...state,
                getStockHistoryLoad: true
            }
        case ApiConstants.API_GET_STOCK_HISTORY_SUCCESS:
            return {
                ...state,
                getStockHistoryLoad: false,
                getStockHistoryData: action?.result
            }
        case ApiConstants.API_GET_STOCK_MOVEMENT_HISTORY_LOAD:
            return {
                ...state,
                getStockMovementHistoryLoad: true
            }
        case ApiConstants.API_GET_STOCK_MOVEMENT_HISTORY_SUCCESS:
            return {
                ...state,
                getStockMovementHistoryLoad: false,
                getStockMovementHistoryData: action?.result
            }
        case ApiConstants.API_ADMIN_ADJUST_STOCK_LOAD:
            return {
                ...state,
                adminAdjustStockLoad: true
            }
        case ApiConstants.API_ADMIN_ADJUST_STOCK_SUCCESS:
            return {
                ...state,
                adminAdjustStockLoad: false,
                adminAdjustStockData: action?.result
            }
        case ApiConstants.API_GET_COMBO_COMPONENT_OPTIONS_LOAD:
            return {
                ...state,
                getComboComponentOptionsLoad: true
            }
        case ApiConstants.API_GET_COMBO_COMPONENT_OPTIONS_SUCCESS:
            return {
                ...state,
                getComboComponentOptionsLoad: false,
                getComboComponentOptionsData: action?.result?.getComboComponentOptions
            }
        case ApiConstants.API_GET_COMBO_ITEMS_LOAD:
            return {
                ...state,
                getComboItemsLoad: true,
                getComboItemsData: null,
                getComboItemsFor: action?.payload?.productDetailId ?? null
            }
        case ApiConstants.API_GET_COMBO_ITEMS_SUCCESS:
            // Ignore a response for a product other than the one last asked
            // for (Edit sheet reopened on another combo before it landed).
            if (action?.payload?.productDetailId !== state.getComboItemsFor) return state;
            return {
                ...state,
                getComboItemsLoad: false,
                getComboItemsData: action?.result?.getComboItems
            }
        default:
            return state;
    }
}

export default ApparelReducerState;